// Firebase配置
import { initializeApp, getApps } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  doc, 
  setDoc, 
  deleteDoc,
  query,
  orderBy,
  limit,
  where,
  getDoc,
  updateDoc,
  serverTimestamp,
  startAfter,
  runTransaction,
  arrayUnion,
  arrayRemove,
  addDoc
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase 配置
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "destinycrystal-ff557.firebaseapp.com",
  projectId: "destinycrystal-ff557",
  storageBucket: "destinycrystal-ff557.firebasestorage.googleapis.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// 如果环境变量未设置，使用开发环境配置
if (!process.env.REACT_APP_FIREBASE_API_KEY) {
  console.warn("环境变量未设置，使用开发环境配置");
  firebaseConfig.apiKey = "AIzaSyBrqKLaCsDTEBizh7uNrSrMDdEaGOoi2jc";
  firebaseConfig.messagingSenderId = "381442645598";
  firebaseConfig.appId = "1:381442645598:web:b3ed9c96a1e2a16a6adcd7";
  firebaseConfig.measurementId = "G-EFRYE4ESEE";
}

// 初始化Firebase - 确保只初始化一次
let app;
try {
  if (!getApps().length) {
    console.log("初始化新的Firebase实例");
    app = initializeApp(firebaseConfig);
  } else {
    console.log("使用现有的Firebase实例");
    app = getApps()[0];
  }
} catch (error) {
  console.error("Firebase初始化错误:", error);
  throw error; // 在开发环境中抛出错误，以便及时发现问题
}

// 获取Firestore实例
const db = getFirestore(app);

// 获取Auth实例
const auth = getAuth(app);

// 获取Storage实例
const storage = getStorage(app);

// 获取Functions实例 - 使用标准方法指定区域
const functions = getFunctions(app, 'asia-southeast1');

// 设置更长的超时时间的函数实例，用于长时间运行的AI请求
const functionsWithLongTimeout = getFunctions(app, 'asia-southeast1');

// 记录区域配置信息（不修改内部属性）
console.log("Firebase Functions配置 - 使用asia-southeast1区域");

export { 
  app, 
  db, 
  auth, 
  storage, 
  functions,
  functionsWithLongTimeout,
  // Re-export Firestore functions
  collection,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  query,
  orderBy,
  limit,
  where,
  getDoc,
  updateDoc,
  serverTimestamp,
  startAfter,
  runTransaction,
  arrayUnion,
  arrayRemove,
  addDoc
};
export default app;